import React, { useContext } from 'react';
import { Tag } from '@onward-delivery/design';
import { UserContext } from '@/components/App';
import { CorpAdminContext } from '@/components/CorporateUsers/store';
import { CopyableId } from '@/components/CorporateUsers/modals/blocks';
import { CardRow, SystemCard } from './blocks';
import TmsCard from './TmsCard';

const NOTICE_CLASS = 'rounded-lg border border-slate-200 bg-white p-4 text-[13px]';

const PlatformCard = () => {
    const { client: carrier } = useContext(UserContext);
    const status = carrier.approved ? <Tag variant="primary">Live</Tag> : <Tag variant="warning">Pending approval</Tag>;

    return (
        <SystemCard
            badge="O"
            badgeClassName="bg-slate-900"
            title="Onward platform"
            subtitle="the master link — every order flows through this"
        >
            <CardRow label="Account ID">
                <CopyableId label="Account ID" value={carrier.client_id} />
            </CardRow>
            <CardRow label="Login">{carrier.email}</CardRow>
            <CardRow label="Status">{status}</CardRow>
        </SystemCard>
    );
};

const Integrations = () => {
    const { state } = useContext(CorpAdminContext);
    const { defaultIntLoading, defaultIntError } = state;

    let tmsCard = <TmsCard />;
    if (defaultIntLoading) tmsCard = <span className={`${NOTICE_CLASS} text-slate-500`}>Loading…</span>;
    if (defaultIntError)
        tmsCard = <span className={`${NOTICE_CLASS} text-destructive`}>Couldn&apos;t load the integrations.</span>;

    return (
        <div className="onward-design">
            <section className="flex flex-col gap-3 p-6">
                <h3 className="m-0 border-l-4 border-primary pl-2 text-[15px] font-bold text-slate-900">
                    Integrations
                </h3>
                <div className="grid items-start gap-4 lg:grid-cols-2">
                    <PlatformCard />
                    {tmsCard}
                </div>
            </section>
        </div>
    );
};

export default Integrations;
